import { render, staticRenderFns } from "./bankAccounts.vue?vue&type=template&id=e82ae194&"
import script from "./bankAccounts.vue?vue&type=script&lang=js&"
export * from "./bankAccounts.vue?vue&type=script&lang=js&"
import style0 from "./bankAccounts.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports